import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { CardTemplate } from '../../../../constants';
import { messages } from '../../../../messages';
import { useAIAnswerContext } from '../../../ai-answer-context';
import { onAIAnswerReturnLinkClick } from '../../../analytics';
import { AIAnswerCloseLabelWrapper, AIAnswerResultBlurSection, AIAnswerResultBlurSectionText, AIAnswerResultSection } from '../styled';
export var PlaintextResultComponent = function PlaintextResultComponent() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isResultOverflow = _useState2[0],
    setResultOverflow = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isResultExpanded = _useState4[0],
    setResultExpanded = _useState4[1];
  var wrapperRef = useRef(null);
  var contentRef = useRef(null);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    isReadingAids = _useAIAnswerContext.isReadingAids,
    cardTemplate = _useAIAnswerContext.cardTemplate,
    onClose = _useAIAnswerContext.onClose;
  var answerString = commonAttributes.answerString;
  var onCloseDialog = useCallback(function () {
    fireAnalyticsEvent(onAIAnswerReturnLinkClick(commonAttributes));
    onClose === null || onClose === void 0 || onClose();
  }, [commonAttributes, fireAnalyticsEvent, onClose]);
  var enableShowMoreBlur = cardTemplate === CardTemplate.DEFAULT && isReadingAids;
  useEffect(function () {
    if (!wrapperRef.current || !contentRef.current) {
      return;
    }
    var resizeObserver = new ResizeObserver(function () {
      var _wrapperRef$current$o, _wrapperRef$current, _contentRef$current$o, _contentRef$current;
      if (((_wrapperRef$current$o = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.offsetHeight) !== null && _wrapperRef$current$o !== void 0 ? _wrapperRef$current$o : 0) < ((_contentRef$current$o = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.offsetHeight) !== null && _contentRef$current$o !== void 0 ? _contentRef$current$o : 0)) {
        setResultOverflow(true);
      } else {
        setResultOverflow(false);
      }
    });
    resizeObserver.observe(contentRef.current);
    return function () {
      return resizeObserver.disconnect();
    };
  }, []);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(AIAnswerResultSection, {
    isReadingAids: isReadingAids && cardTemplate === CardTemplate.DEFAULT,
    ref: wrapperRef,
    isExpanded: isResultExpanded
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, answerString), enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/React.createElement(AIAnswerResultBlurSection, {
    onClick: function onClick() {
      return setResultExpanded(true);
    }
  }, /*#__PURE__*/React.createElement(AIAnswerResultBlurSectionText, null, formatMessage(messages.ai_answer_expand_button_label)))), !isReadingAids && onClose && /*#__PURE__*/React.createElement(AIAnswerCloseLabelWrapper, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.ai_answer_dialog_cancel_label, {
    values: {
      searchResultsLink:
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      React.createElement("a", {
        onClick: onCloseDialog
      }, formatMessage(messages.ai_answer_dialog_search_results_label))
    }
  }))));
};